"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * Espilon Layouts Module
 */
var EpsilonLayouts = /** @class */ (function () {
    /**
     * Class Constructor
     * @param {{container: JQuery; setting: void; params: {value: number; id: string}}} control
     */
    function EpsilonLayouts(control) {
        /**
         * Buttons
         */
        this.html = {
            buttonLeft: '<a href="#" data-action="left"><span class="dashicons dashicons-arrow-left"></span> </a>',
            buttonRight: '<a href="#" data-action="right"><span class="dashicons dashicons-arrow-right"></span> </a>',
        };
        /**
         * Number of active columns
         */
        this.activeColumns = null;
        /**
         * Redundant constant for columns
         */
        this.colClasses = 'col12 col11 col10 col9 col8 col7 col6 col5 col4 col3 col2 col1';
        this.control = control;
        this.context = this.control.container;
        this.layoutButtons = this.context.find('.epsilon-control-group > a');
        this.resizeButtons = this.context.find('.epsilon-layouts-setup > .epsilon-column > a');
        this.maxColumns = this.layoutButtons.length;
        this.minSpan = parseFloat(this.control.params.minSpan);
        this.lastColumnsState = null;
        this.dataLink = this.context.find('[data-customize-setting-link]').first();
        /**
         * Handle actions
         */
        this.handle_actions();
        /**
         * Whenever the column count or size changes, we save data to the hidden field
         */
        this.context.on('epsilon_column_count_changed epsilon_column_size_changed', this._save);
    }
    /**
     * Handle the click events in the control
     */
    EpsilonLayouts.prototype.handle_actions = function () {
        /**
         * Hide / show columns
         */
        this._advanced_toggler();
        /**
         * Column resize event ( + / - buttons )
         */
        this._column_resize();
        /**
         * Addition removal of columns events
         */
        this._column_recount();
        this._layout_select();
        this._equalize_columns();
    };
    /**
     * Advanced toggler
     *
     * @private
     */
    EpsilonLayouts.prototype._advanced_toggler = function () {
        /**
         * On clicking the advanced options toggler,
         */
        this.context.on('click', '.epsilon-control-advanced', function (e) {
            e.preventDefault();
            jQuery(this).toggleClass('active');
            jQuery('#' + jQuery(this).attr('data-unique-id')).slideToggle().addClass('active');
        });
    };
    /**
     * Column Resizer
     * @private
     */
    EpsilonLayouts.prototype._column_resize = function () {
        var self = this;
        var position, elementToSubtractFrom, elementToAddOn;
        this.context.on('click', '.epsilon-column > a', function (e) {
            elementToAddOn = jQuery(this).parent();
            position = elementToAddOn.index();
            if ('right' === jQuery(this).attr('data-action')) {
                elementToSubtractFrom = self.context.find('.epsilon-layouts-setup > .epsilon-column').eq(position + 1);
            }
            else {
                elementToSubtractFrom = self.context.find('.epsilon-layouts-setup > .epsilon-column').eq(position - 1);
            }
            self._calc_column_resize(elementToSubtractFrom, elementToAddOn);
        });
    };
    /**
     * Handle addition/removal of columns
     * @private
     */
    EpsilonLayouts.prototype._column_recount = function () {
        var self = this;
        var columns, operation, i, j;
        this.context.on('epsilon_column_count_change', function (e) {
            /**
             * Update instance variables
             */
            self.activeColumns = parseFloat(e.columns.selected);
            self.lastColumnsState = e.columns.beforeSelection;
            /**
             * In case we don't have anything to modify, we can terminate here
             */
            if (self.activeColumns === self.lastColumnsState) {
                return;
            }
            /**
             * Are we adding or subtrating?
             */
            operation = self.lastColumnsState < self.activeColumns ? 'adding' : 'subtracting';
            i = self.activeColumns - self.lastColumnsState;
            if ('subtracting' === operation) {
                self.context.find('.epsilon-layouts-setup > .epsilon-column').
                    slice(-(self.lastColumnsState - self.activeColumns)).
                    remove();
            }
            else {
                for (j = 0; j < i; j++) {
                    self.context.find('.epsilon-layouts-setup').
                        append('<div class="epsilon-column col4">' +
                        self.html.buttonLeft +
                        self.html.buttonRight +
                        '</div>');
                }
            }
            /**
             * Trigger event to changed
             */
            self.context.trigger({
                type: 'epsilon_column_count_changed',
                instance: self
            });
        });
    };
    /**
     * When selecting a layout, recalc/remove/readd divs in the container
     *
     * @private
     */
    EpsilonLayouts.prototype._layout_select = function () {
        var self = this;
        var columns;
        this.layoutButtons.on('click', function (e) {
            e.preventDefault();
            var selected = jQuery(this).attr('data-button-value');
            /**
             * Handle addition/deletion through jQuery events
             */
            self.context.trigger({
                type: 'epsilon_column_count_change',
                columns: {
                    selected: parseFloat(selected),
                    beforeSelection: self.context.find('.epsilon-layouts-setup > .epsilon-column').length
                }
            });
            /**
             * Visual changes
             */
            jQuery(this).addClass('active').siblings('a').removeClass('active');
        });
    };
    /**
     * Equalize coolumns, this is happening after a new layout is selected
     * @private
     */
    EpsilonLayouts.prototype._equalize_columns = function () {
        var self = this;
        this.context.on('epsilon_column_count_changed', function (e) {
            switch (self.activeColumns) {
                case 2:
                    self.context.find('.epsilon-column').removeClass(self.colClasses);
                    self.context.find('.epsilon-column').first().addClass('col8').attr('data-columns', (8));
                    self.context.find('.epsilon-column').last().addClass('col4').attr('data-columns', (4));
                    break;
                default:
                    if (null === self.activeColumns) {
                        return;
                    }
                    self.context.find('.epsilon-column').
                        removeClass(self.colClasses).
                        addClass('col' + (12 / self.activeColumns)).
                        attr('data-columns', (12 / self.activeColumns));
                    break;
            }
        });
    };
    /**
     * Change spans accordingly
     *
     * @param subtract
     * @param add
     */
    EpsilonLayouts.prototype._calc_column_resize = function (subtract, add) {
        var columns = subtract.attr('data-columns'), addColumns;
        if ('undefined' === typeof columns) {
            return;
        }
        columns = parseFloat(columns);
        if (parseFloat(columns) === this.minSpan) {
            return;
        }
        addColumns = add.attr('data-columns');
        addColumns = parseFloat(addColumns);
        subtract.attr('data-columns', columns - 1).removeClass(this.colClasses).addClass('col' + (columns - 1));
        add.attr('data-columns', addColumns + 1).removeClass(this.colClasses).addClass('col' + (addColumns + 1));
        /**
         * Trigger event to change
         */
        this.context.trigger({
            type: 'epsilon_column_size_changed',
            instance: this
        });
    };
    /**
     * Save state in a json
     * @private
     */
    EpsilonLayouts.prototype._save = function (e) {
        var json = {
            columnsCount: e.instance.activeColumns,
            columns: {}
        };
        jQuery.each(e.instance.context.find('.epsilon-column'), function (index) {
            var columns = jQuery(this).attr('data-columns');
            if ('undefined' === typeof columns) {
                return;
            }
            columns = parseFloat(columns);
            var Obj = {
                index: index + 1,
                span: columns
            };
            json.columns[index + 1] = Obj;
        });
        if (null === json.columnsCount) {
            json.columnsCount = e.instance.context.find('.epsilon-column').length;
        }
        e.instance.dataLink.val(JSON.stringify(json)).trigger('change');
    };
    return EpsilonLayouts;
}());
exports.EpsilonLayouts = EpsilonLayouts;



//////////////////
// WEBPACK FOOTER
// ./assets/vendors/epsilon-framework/customizer/controls/layouts.ts
// module id = 42
// module chunks = 0